export enum ETechnology {
    Cpp = "c++",
    CSharp = "c#",
    Python = "python",
    React = "react",
    Fritzing = "fritzing",
    CSS = "CSS",
    HTML = "HTML",
    Firebase = "firebase",
    JavaScript = "javaScript",
    RaspberryPi = "raspberry Pi",
    OpenSCAD = "openSCAD",
    MongoDB = "mongoDB",
    Twitter = "twitter",
    PostgresSQL = "postgres-SQL",
    Arduino = "arduino",
    Instagram = "instagram",
    Facebook = "facebook",
    Youtube = "youtube",
    LinkedIn = "linkedIn",
    Twitch = "twitch",
    TypeScript = "typeScript",
    Github = "github",
    Unity = "unity"
}